import { NewMatterNotificationApprovalIntroduction } from '@repo/ui/NewMatterNotificationApprovalIntroduction'
import { NewMatterNotificationApprovalClientMapping } from '@repo/ui/NewMatterNotificationApprovalClientMapping'
import { NewMatterNotificationApprovalCOISSelect } from '@repo/ui/NewMatterNotificationApprovalCOISSelect'

export default [
  {
    stageLabel: 'New matter notification',
    stageId: 'new-matter-notification-approval',
    steps: [
      {
        stepLabel: 'Introduction',
        stepDescription: 'Please read the instructions below before starting',
        stepId: 'introduction',
        skippable: false,
        component: NewMatterNotificationApprovalIntroduction,
        uniqueId: 'new-matter-notification-approval-introduction'
      },
      {
        stepLabel: 'Client mapping',
        stepDescription: 'Select, search or create a new client for this matter',
        stepId: 'client-mapping',
        skippable: false,
        component: NewMatterNotificationApprovalClientMapping,
        uniqueId: 'new-matter-notification-approval-client-mapping'
      },
      {
        stepLabel: 'Conflict of interest search',
        stepDescription: 'Select whether you want to do a conflict of interest search on this client',
        stepId: 'cois-select',
        skippable: false,
        component: NewMatterNotificationApprovalCOISSelect,
        uniqueId: 'new-matter-notification-approval-cois-select'
      }
    ]
  }
]
